import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getNotice = (noticeId) => Axios.get(`/notices/${noticeId}`);

const useNotice = (noticeId) => {
    return useQuery({
        queryKey: ['notice', noticeId],
        queryFn: () => getNotice(noticeId),
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
        enabled: noticeId ? true : false,
    });
};

const forceReloadNotice = (ID) => {
    queryClient.invalidateQueries({ queryKey: ['notice', ID] });
};

const onDeleteNotice = ({ ID }) => Axios.delete(`/notices/${ID}`);

const useDeleteNotice = () => {
    return useMutation({
        mutationFn: onDeleteNotice,
        onSuccess: (data, variables) => {
            if (variables.ID !== variables.noticeId) {
                forceReloadNotice(variables.noticeId);
            }
        },
    });
};

const onUpdateNotice = ({ noticeData }) => Axios.put('/notices', noticeData);

const useUpdateNotice = () => {
    return useMutation({
        mutationFn: onUpdateNotice,
        onSuccess: (data, variables) => {
            forceReloadNotice(variables.noticeData.ID);
        },
    });
};

const onAddNotice = ({ noticeData }) => Axios.post('/notices', noticeData);

const useAddNotice = () => {
    return useMutation({
        mutationFn: onAddNotice,
        onSuccess: (data, variables) => {
            forceReloadNotice(data.ID);
        },
    });
};

export { useNotice, useDeleteNotice, useUpdateNotice, useAddNotice, forceReloadNotice };
